module.exports = __webpack_public_path__ + "img/odoo-for-marketing.39049151.png";